import FarmChip from "@/components/Chip/FarmChip";
import ApyButton from "@/components/Farm/ApyButton";
import CardUserSection from "@/components/Farm/CardUserSection";
import PoolLogo from "@/components/Farm/PoolLogo";
import Col from "@/components/Layout/Flex/Col";
import Row from "@/components/Layout/Flex/Row";
import RowBetween from "@/components/Layout/Flex/RowBetween";
import { ChainId, type ChainType, fallbackChainId } from "@/constants/chain-specific";
import type { RequiredFarmChainType } from "@/constants/project-specific";
import { FARM_PAGE_CONFIG } from "@/constants/project-specific/farms";
import type { Farm } from "@/constants/project-specific/farms/types";
import { formatBalance } from "@/util/balance/formatBalance";
import { getMasterChefConfigBySlug } from "@/util/contracts/masterchef";
import { Card, CardBody, CardHeader, Tooltip } from "@heroui/react";
interface FarmCardProps {
  farm: Farm;
  index: number;
  chain?: ChainType;
}
export default function FarmCard({
  farm,
  index,
  chain
}: FarmCardProps) {
  const isSinglePool: boolean = !farm?.tokenB;
  // const { farmData } = useFarmUserData(farm);
  const cardKey = `FarmCard_${farm?.masterChefSlug && `${farm.masterChefSlug}_`}${index}`;
  const dexName = farm?.dex?.name ?? "";
  const masterChef = getMasterChefConfigBySlug(farm?.masterChefSlug, chain as RequiredFarmChainType ?? ChainId.SHIBARIUM as RequiredFarmChainType) ?? FARM_PAGE_CONFIG.defaultChef[fallbackChainId];
  return <>
      <Card key={cardKey} className={farm.display && farm.display === "featured" ? "w-[300px] cards-farm-featured" : "w-[300px] cards-farm"}>
        <CardHeader className="bg-gradient-to-t from-gray-500/0 via-gray-500/20 to-gray-500/20 to-20% pb-4">
          <RowBetween className="w-full">
            <div>
              <PoolLogo farm={farm} />
            </div>
            <Col className="place-self-center">
              <div className="text-md md:text-lg text-center">
                {farm?.tokenA.symbol}
                {!isSinglePool && `-${farm?.tokenB?.symbol}`}
              </div>
              {dexName && <FarmChip name={masterChef.name} size="sm" logo={masterChef.rewardToken.logo} className="place-self-end" />}
            </Col>
          </RowBetween>
        </CardHeader>
        <CardBody>
          <Row className="justify-between pb-1">
            <Tooltip delay={1000} content={<div className="px-1 py-2">
                  <div className="text-small font-bold">Estimated APY</div>
                  <div className="text-tiny">
                    Estimated based on current on-chain values
                  </div>
                  <div className="text-tiny">
                    NOT meant to represent a guaranteed return
                  </div>
                </div>}>
              <div className="w-full flex justify-start cursor-help">EAPY:</div>
            </Tooltip>
            <div className="w-full flex justify-end">
              <div className="flex">
                <ApyButton masterChef={masterChef} farm={farm} />
                <Tooltip content={<div className="px-1 py-2">
                      <div className="text-small font-bold">Estimated APY</div>
                      <div className="text-tiny">
                        Estimated based on current on-chain values
                      </div>
                      <div className="text-tiny">
                        NOT meant to represent a guaranteed return
                      </div>
                    </div>} delay={1000}>
                  {farm.apy && `${farm.apy > 10 ? Math.round(farm.apy).toLocaleString() : farm.apy < 5 ? farm.apy.toFixed(2) : Math.round(farm.apy)}%`}
                </Tooltip>
              </div>
            </div>
          </Row>
          <Row className="justify-between pb-1">
            <div className="w-full flex justify-start">Earn:</div>
            <div className="w-full flex justify-end">
              {masterChef.rewardToken.symbol}
            </div>
          </Row>
          <Row className="justify-between pb-1">
            <div className="w-full flex justify-start">TVL:</div>
            <div className="w-full flex justify-end">
              {farm?.totalValue && farm?.totalValue > 0 ? `$${formatBalance(farm?.totalValue)}` : "-"}
            </div>
          </Row>
          <CardUserSection farm={farm} index={index} masterChef={masterChef} />
        </CardBody>
        {/*<CardFooter>
          <Button
            variant="shadow"
            size="lg"
            startContent={
              <Icon icon="mingcute:down-fill" className="text-lg" />
            }
            endContent={<Icon icon="mingcute:down-fill" className="text-lg" />}
            className="w-full mb-1"
          >
            Details
          </Button>
         </CardFooter> */}
      </Card>
    </>;
}